import { Card } from "@/components/ui/card";

export const RevenueForecast = () => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Revenue Forecast</h3>
      <p className="text-muted-foreground">Revenue forecasts will appear here.</p>
    </Card>
  );
};